module.exports = __webpack_public_path__ + "static/media/file1.b7e60c6d.png";